angular.module 'zc.core'

# To communicate with Rails API
.factory 'Api', ($httpOnce) ->
  class Api
    @basePath: if ZC_CONFIG?.RAILS_API_URL && ZC_CONFIG?.RAILS_API_PORT then "#{ZC_CONFIG.RAILS_API_URL}:#{ZC_CONFIG.RAILS_API_PORT}" else ""
    @setBasePath: (path) ->
      @basePath = path

    @path: (endpoint) ->
      # Don't need to specify the server directory
      # because contains no facade login
      "#{@basePath}#{endpoint}"

    @post: (path, data, opts = {}) ->
      opts.method = 'POST'
      @request path, data, opts

    @get: (path, data, opts = {}) ->
      opts.method = 'GET'
      @request path, data, opts

    @put: (path, data, opts = {}) ->
      opts.method = 'PUT'
      @request path, data, opts

    @patch: (path, data, opts = {}) ->
      opts.method = 'PATCH'
      @request path, data, opts

    @delete: (path, data, opts = {}) ->
      opts.method = 'DELETE'
      @request path, data, opts

    @request: (path, data, opts = {}) ->
      reqParams = _.assignIn {}, {
        url: Api.path(path)
        data: data
      }, opts
      $httpOnce(reqParams)

  Api



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/api.service.coffee